import onElelementExistRunOnce from 'helpers/jquery/onElementExistRunOnce';

onElelementExistRunOnce('.machine_maintenance_report_form', () => {
  import('./internal/machine_maintenance_report_form').then(({ default: Component }) => Component());
});

onElelementExistRunOnce('.maintenance-records-report-table', () => {
  import('./internal/maintenance-records-report-table').then(({ default: Component }) => Component());
});
